import { Paper as BasePaper, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Stack)`
  width: 90vw;
  max-width: ${(p) => p.theme.spacing(170)};
  background: ${(p) => p.theme.palette.common.white};
  padding: ${(p) => p.theme.spacing(2.5, 4.5)};
`;

export const Paper = styled(BasePaper)`
  &.MuiPaper-root {
    padding: 0 ${(p) => p.theme.spacing(1)} !important;
  }
`;
